<div class="bg-white w-full" *ngIf="webComponent">
    <mft-wc-wrapper
        [options]="webComponent.options"
        [props]="webComponent.props"
        [events]="webComponent.events"
    ></mft-wc-wrapper>
</div>
